import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, DialogActions, DialogContent, DialogTitle, Typography, styled } from 'netline-ui';

import { ModuleVersion, useAboutModules } from '../../../Navigation';

import ContentType from './consts';
import styles, { versionContentClasses } from './VersionContent.styles';

const VersionContentRoot = styled('div', { name: versionContentClasses.$name })(styles);

type VersionContentProps = {
  onContentChange: (contentType: ContentType | null) => void;
};

const VersionContent = ({ onContentChange }: VersionContentProps) => {
  const { t } = useTranslation();

  const { structuredModuleVersions: moduleVersions } = useAboutModules(null);

  const handleCloseClick = useCallback(() => onContentChange(null), [onContentChange]);
  const handleBackButtonClick = useCallback(() => onContentChange(ContentType.GENERAL), [onContentChange]);
  const handleCopyToClipboardClick = useCallback(
    () => navigator.clipboard.writeText(JSON.stringify(moduleVersions)),
    [moduleVersions],
  );

  return (
    <VersionContentRoot className={versionContentClasses.root}>
      <DialogTitle disableTypography variant="h3" onClose={handleCloseClick} onBack={handleBackButtonClick}>
        <Typography variant="h3" component="span" className={versionContentClasses.titleText}>
          {t('about.versions')}
        </Typography>
      </DialogTitle>
      <DialogContent className={versionContentClasses.content}>
        <ModuleVersion moduleVersions={moduleVersions} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCopyToClipboardClick}>
          {t('about.copy_version_info')}
        </Button>
      </DialogActions>
    </VersionContentRoot>
  );
};
export default VersionContent;
